<template>
    <section class="our-team-wrapper grey-bg pt-80px pb-80px">
        <div class="container">
            <div class="row" v-if="dlabData.aboutus.teamData.title">
                <div class="col-md-12">
                    <h1 class="section-title text-center mb-30px">{{dlabData.aboutus.teamData.title}}</h1>
                </div>
            </div>

            <div class="row responsive-tablet-col-3">
                <div class="col-md-3" v-for="(member, i) in dlabData.aboutus.teamData.members" :key="i">
                    <team-member :member="member" />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import dlabData from '@/store/store';
import TeamMember from '../cards/TeamMember.vue'

export default {
    name: 'OurTeam',
    components: {
        TeamMember
    },
    data() {
        return {
            dlabData
        }
    }
}
</script>